import { render, staticRenderFns } from "./AddAlbuns.vue?vue&type=template&id=7016ff20&"
import script from "./AddAlbuns.vue?vue&type=script&lang=js&"
export * from "./AddAlbuns.vue?vue&type=script&lang=js&"
import style0 from "./AddAlbuns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports